module.exports = __webpack_public_path__ + "img/pin.14a64cc5.svg";